var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24HoursDesk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#666",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.222 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#666",
    cx: 2.778,
    cy: 1.667,
    r: 1.667
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 2.778,
    cy: 6.111,
    r: 2.778
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.222 11.667h15.556v7.777H4.222z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 11.667h20"
  })))));
}
export default Svg24HoursDesk;